<template>
  <v-menu
    class="rounded-lg"
    v-model="menu"
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <span class="mr-2 font-weight-bold">{{
        t("hello", { name: $store.state.auth.user.firstName })
      }}</span>
      <v-avatar v-bind="attrs" v-on="on" color="primary"
        ><v-icon color="white" size="30">face</v-icon></v-avatar
      >
    </template>
    <v-card class="rounded-lg">
      <v-list dense>
<!--         <v-list-item>
          <v-list-item-icon class="mr-4"
            ><v-icon class="material-icons-outlined"
              >person</v-icon
            ></v-list-item-icon
          >
          <v-list-item-title>{{ t("myData") }}</v-list-item-title>
        </v-list-item> -->

        <v-list-group>
          <template v-slot:activator>
            <v-list-item-icon class="mr-4"
              ><v-icon class="material-icons-outlined"
                >support_agent</v-icon
              ></v-list-item-icon
            >
            <v-list-item-title>{{ t("contact") }}</v-list-item-title>
          </template>

          <v-list-item>
            <v-list-item-title class="ml-3">{{$store.state.config.phoneNumber}}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-icon class="mr-4"
              ><v-icon class="material-icons-outlined"
                >language</v-icon
              ></v-list-item-icon
            >
            <v-list-item-title>{{
              t(`language.${$store.state.config.lang || 'en'}`)
            }}</v-list-item-title>
          </template>

          <v-list-item @click="$root.changeLang('es')">
            <v-list-item-title class="ml-3">{{
              t("language.es")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$root.changeLang('en')">
            <v-list-item-title class="ml-3">{{
              t("language.en")
            }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item @click="logout">
          <v-list-item-icon class="mr-4"
            ><v-icon class="material-icons-outlined"
              >logout</v-icon
            ></v-list-item-icon
          >
          <v-list-item-title>{{ t("logout") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>

import { mapActions } from "vuex";
export default {
  data: () => ({
    menu: false,
  }),
  methods: {
    ...mapActions("auth", ['logout']),
    t(key, options = {}) {
      return this.$t(`information.menu.${key}`, options);
    },
  },
};
</script>

<style></style>
